export default (() => {
    $(document).scroll(function() {
        var height =  $('.top-bar').outerHeight();

        if($(window).scrollTop() > height) {
            $('nav').addClass('fixed');
        } else {
            $('nav').removeClass('fixed');
        }
     });

     $('.nav-toggle').click(function() {
         $('#menu-header').slideToggle('fast', function(){

            if($('body').hasClass('no-scroll')) {
                $('body').removeClass('no-scroll');
                $('.nav-toggle').removeClass('open');
                return;
            }

            $('.nav-toggle').addClass('open');
             $('body').addClass('no-scroll');
         });
     })

     $('#menu-header .arrow').click(function() {
        var parent = $(this).parent();
        var wrapper = $(this).parents('li');

        if(parent.hasClass('open')) {
            parent.removeClass('open');
            wrapper.removeClass('open');
            return;
        }

        parent.addClass('open');
        wrapper.addClass('open');
    })


});




// WEBPACK FOOTER //
// ./scripts/components/nav.js